import { Gateway } from '../../../../shared/api/gateway/Gateway';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';

export type ILoaderMyVehicles = () => Promise<IVehicle[]>;

export function getVehiclesLoader(api: Gateway): ILoaderMyVehicles {
	return async () => {
		const vehicles = await api.vehicle().getMyVehicles();
		return vehicles;
	};
}
